import { render, staticRenderFns } from "./ProductSliderTheme0.vue?vue&type=template&id=2b784a92&scoped=true"
import script from "./ProductSliderTheme0.vue?vue&type=script&lang=js"
export * from "./ProductSliderTheme0.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderTheme0.vue?vue&type=style&index=0&id=2b784a92&prod&scoped=true&lang=css"
import style1 from "./ProductSliderTheme0.vue?vue&type=style&index=1&id=2b784a92&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b784a92",
  null
  
)

export default component.exports